import trim, {Trim} from "./trim";

export default function trimEnd(value: string, chars: string|string[]) {
    return trim(value, chars, Trim.END);
}
